import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Form } from "antd";
import { TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
/**
 * Placeholder Form.Item for extends object. Otherwise it's not available in the form instance.
 */ function FormFieldTemplateExtends() {
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        hidden: true,
        name: TemplateMetaDataField.Extends,
        shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
        children: /*#__PURE__*/ _jsx(_Fragment, {})
    });
}
export { FormFieldTemplateExtends };
